import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=c5e56f46&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=c5e56f46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e56f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5e56f46')) {
      api.createRecord('c5e56f46', component.options)
    } else {
      api.reload('c5e56f46', component.options)
    }
    module.hot.accept("./MainNavigation.vue?vue&type=template&id=c5e56f46&scoped=true", function () {
      api.rerender('c5e56f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainNavigation.vue"
export default component.exports